jQuery( document ).ready(function() {
    initSwiper();

    function initSwiper() {
        if (jQuery(".our-essentials-slider-swiper").length > 0) {
            const ourEssentialsSwiper = new Swiper('.our-essentials-slider-swiper', {
                slidesPerView: 'auto',
                spaceBetween: 30,
                centeredSlides: true,
                navigation: {
                    nextEl: ".our-essentials-next",
                    prevEl: ".our-essentials-prev",
                },
                preloadImages: false,
                lazy: true,
                watchSlidesProgress: true,
            });
        }
    }
})